const IOS_PRO_APP_STORE_ID = String(import.meta.env.VITE_IOS_APP_STORE_ID || "").trim();
const IOS_EXPLORE_APP_STORE_ID = String(import.meta.env.VITE_IOS_EXPLORE_APP_STORE_ID || "").trim();

const ANDROID_PRO_PACKAGE = "co.buukd.app";
const ANDROID_EXPLORE_PACKAGE = "co.buukd.explore";

function iosAppUrl(appStoreId: string, searchTerm: string): string {
  if (appStoreId) {
    return `https://apps.apple.com/app/id${appStoreId}`;
  }
  return `https://apps.apple.com/search?term=${encodeURIComponent(searchTerm)}`;
}

function playStoreUrl(packageName: string): string {
  return `https://play.google.com/store/apps/details?id=${packageName}`;
}

export const BUUKD_PRO_STORE_LINKS = {
  ios: iosAppUrl(IOS_PRO_APP_STORE_ID, "Buukd"),
  android: playStoreUrl(ANDROID_PRO_PACKAGE),
} as const;

export const BUUKD_EXPLORE_STORE_LINKS = {
  ios: iosAppUrl(IOS_EXPLORE_APP_STORE_ID, "Buukd Explore"),
  android: playStoreUrl(ANDROID_EXPLORE_PACKAGE),
} as const;
